import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { StaffFrontDeskPanelAuthService } from './staff-front-desk-panel-auth.service';
import { StaffFrontDeskPanelService } from './staff-front-desk-panel.service';

@Injectable({
  providedIn: 'root'
})
export class StaffFrontDeskPanelAuthGuardService implements CanActivate{

  constructor(
    public auth: StaffFrontDeskPanelAuthService, 
    public router: Router,
    public staffFrontDeskPanelService: StaffFrontDeskPanelService
  ) { }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if(!this.auth.isAuthenticated()) {
      this.router.navigate(['/front-desk/login'])
      return false;
    }
    else {
      let response = this.staffFrontDeskPanelService.getHotelStaffUserSessionData()
      if(response['status'] == 1){
        let hotelStaffUserData = response['hotelStaffUserData']
        return new Promise(res => {
          this.staffFrontDeskPanelService.validateCurrentHotelStaffDetail(
            {'staff_id': hotelStaffUserData['id']})
            .subscribe(
              (result) => {
                  if(result['status'] == 1) {
                      res(true);
                  } else {
                      this.staffFrontDeskPanelService.clearHotelStaffUserSessionData();
                      this.router.navigate(['/front-desk/login'])
                      res(false);
                  }
              },
          );
        });
      }
    }
  };

}
